export const userTypes = {
    Dictator: 'Dictator',
    Physician: 'Physician',
    PhysicianOfficeEmployee: 'Physician Office Employee'
};


// WEBPACK FOOTER //
// ./src/components/constants/UserTypes.js